import { useState, useEffect, useCallback } from 'react';
import api, { errorMessage, asArray } from '../api';

/**
 * Hämtar en lista med inlägg och laddar äldre på begäran.
 * Delas av flödet och profilen, som bara skiljer sig i vilken adress de
 * frågar och därmed vilka inlägg de får tillbaka.
 */
export default function usePosts(url) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [hasMore, setHasMore] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await api.get(url);
      setPosts(asArray(res.data));
      setHasMore(asArray(res.data).length >= 20);
    } catch (err) {
      setError(errorMessage(err, 'Inläggen kunde inte hämtas.'));
    } finally {
      setLoading(false);
    }
  }, [url]);

  useEffect(() => { load(); }, [load]);

  /** Äldre inlägg, från den sista postens tidsstämpel och bakåt. */
  const loadMore = useCallback(async () => {
    if (posts.length === 0) return;
    const before = posts[posts.length - 1].created_at;

    try {
      const separator = url.includes('?') ? '&' : '?';
      const res = await api.get(`${url}${separator}before=${encodeURIComponent(before)}`);
      setPosts(prev => [...prev, ...asArray(res.data)]);
      setHasMore(asArray(res.data).length >= 20);
    } catch (err) {
      setError(errorMessage(err));
    }
  }, [url, posts]);

  const prepend = useCallback((post) => setPosts(prev => [post, ...prev]), []);
  const remove = useCallback((id) => setPosts(prev => prev.filter(p => p.id !== id)), []);

  return { posts, loading, error, hasMore, load, loadMore, prepend, remove };
}
